/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Product_SubcategoryInputs */

const en_field_product_subcategory = /** @type {(inputs: Field_Product_SubcategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subcategory`)
};

/**
* | output |
* | --- |
* | "Subcategory" |
*
* @param {Field_Product_SubcategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_product_subcategory = /** @type {((inputs?: Field_Product_SubcategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Product_SubcategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_product_subcategory(inputs)
});